export default __webpack_public_path__ + "static/media/t_warning.3adccc6c.svg";